<template>
  <div>
    <v-checkbox
      :id="transactionalId"
      :input-value="transactionalOptIn"
      @change="$emit('update:transactionalOptIn', !!$event)"
    >
      <template #label>
        <span>
          By selecting the checkbox and submitting this form, you opt-in to receive informational
          text messages (inspection booked, inspection cancelled, report ready, etc.) from
          {{ companyName }} via an automated system. Opting out of transactional messages may
          prevent you from receiving updates about your inspection booking and report.
        </span>
      </template>
    </v-checkbox>
    <v-checkbox
      :id="marketingId"
      :input-value="marketingOptIn"
      @change="$emit('update:marketingOptIn', !!$event)"
    >
      <template #label>
        <span>
          By selecting the checkbox and submitting this form, you agree to receive marketing text
          messages from {{ companyName }} via an automated system.
        </span>
      </template>
    </v-checkbox>
    <p class="sms-consent-footnote">
      Message frequency may vary. Standard data rates may apply. Reply 'STOP' to unsubscribe from
      future messages. For more information, reply 'HELP'. Please review our service's
      <a
        href="https://www.spectora.com/privacy/"
        target="_blank"
        rel="noopener"
        style="text-decoration: underline;"
        >Privacy Policy</a
      >
      for more details on how your data is handled.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    companyName: {
      type: String,
      default: '',
    },
    transactionalId: {
      type: String,
      required: true,
    },
    marketingId: {
      type: String,
      required: true,
    },
    transactionalOptIn: {
      type: Boolean,
      default: false,
    },
    marketingOptIn: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.sms-consent-footnote {
  color: #000;
  line-height: 1.2rem;
}
</style>
